import * as estado from './estado/reducer'

//Creamos un objeto combinando todos los reducers parciales.
let globalReducer = {}
Object.keys(estado).forEach(key => globalReducer[key] = estado[key]);

export default globalReducer;